import ActionIcon from '@/components/_common/ActionIcon';
import ItemsSelectedModal, {
  ItemModalRadioSelected,
} from '@/components/_common/ItemsSelectedModal';
import { usePurchaseItemsUpdateByPartId } from '@/core/domain/purchase/purchaseItem/PurchaseItem.hooks';
import { PurchaseItem } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { StockItem } from '@/core/domain/stock/StockItems/StockItems.types';
import { useDisclosure } from '@/hooks';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Tooltip, Divider } from 'antd';
import { useCallback } from 'react';
import { Repeat } from 'react-feather';

interface Props {
  companyId?: number;
  purchaseItem: PurchaseItem;
}

export default function PurchaseItemPartSwap({
  companyId,
  purchaseItem,
}: Props) {
  const [opened, action] = useDisclosure();

  const changeItemByPartId = usePurchaseItemsUpdateByPartId();

  const handleChangeItemByPartId = useCallback(
    async (stockItem?: StockItem) => {
      try {
        if (!stockItem || !purchaseItem?.id) return;

        await changeItemByPartId.mutateAsync({
          partId: stockItem.partId,
          purchaseItemId: purchaseItem?.id,
        });

        action.close();
      } catch {}
    },
    [purchaseItem],
  );

  return (
    <>
      <Tooltip title="Alterar peça">
        <ActionIcon
          onClick={action.open}
          disabled={
            !hasPermissions([Authorities.MOVIMENTATION_PURCHASE_ITEM_EDIT])
          }
        >
          <Repeat size={20} />
        </ActionIcon>
      </Tooltip>

      <Divider style={{ margin: 0 }} type="vertical" />

      <ItemsSelectedModal
        itemsSelected={[]}
        handleVisible={action.close}
        visible={opened}
        onSelectItem={handleChangeItemByPartId}
        companyId={companyId}
        filterDisabled={[ItemModalRadioSelected.OS]}
      />
    </>
  );
}
